import { useState } from "react";
import { useOutletContext, useRevalidator } from "react-router-dom";
import { Typography, Form, Input, Button, message, Tooltip } from "antd";
import ResetPWModal from "./resetPWModal";
import { UserInfo } from "../../interface";
import { updateUserAlias } from "../../apiBridge";

const { Title, Text } = Typography;

const SettingsPage: React.FC = () => {
  const [form] = Form.useForm();
  const user = useOutletContext() as UserInfo;
  const revalidator = useRevalidator();
  // const user = data as UserInfo;

  const [loadingState, setLoadingState] = useState(false);
  const [showResetPWModal, setShowResetPWModal] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  function maskEmail(email: string) {
    if (!email) return "";
    const [name, domain] = email.split("@");
    if (!name || !domain) return email;
    let maskedName = name;

    if (name.length > 2) {
      maskedName = name.slice(0, 2) + "****";
    } else if (name.length === 2) {
      maskedName = name[0] + "****";
    } else {
      maskedName =  "****";
    }

    return `${maskedName}@${domain}`;
  }
  console.log("Settings page");

  const onFinishUpdate = async () => {
    const alias: string = form.getFieldValue("alias");
    if (user) {
      setLoadingState(true);
      const res = await updateUserAlias({ id: user.id, alias });
      setLoadingState(false);
      if (res.status === 200) {
        message.success("Succesfully updated alias");
        revalidator.revalidate();
      }
    }
  };

  return (
    <>
      {contextHolder}
      <ResetPWModal
        isOpen={showResetPWModal}
        controller={setShowResetPWModal}
        username={user.username}
        messageController={messageApi}
        isOwner={user.role === "Owner"}
      />
      <div
        style={{
          background: "white",
          borderRadius: 4,
          boxShadow: "0 0 8px 0 #cbcbcb",
          padding: 20,
        }}
      >
        <Title level={4} style={{ marginBottom: 0 }}>
          Settings
        </Title>
      </div>
      <div
        style={{
          background: "white",
          borderRadius: 4,
          boxShadow: "0 0 8px 0 #cbcbcb",
          padding: 20,
          marginTop: 20,
        }}
      >
        <Title level={5}>User Information</Title>
        <Form
          name="settinguserform"
          layout="vertical"
          autoComplete="off"
          validateTrigger="onSubmit"
          form={form}
          onFinish={onFinishUpdate}
          requiredMark={false}
        >
          <Form.Item
            label="Display Name"
            name="alias"
            extra={
              user.role !== "Owner" && (
                <Text type="secondary" style={{ fontSize: 12 }}>
                  Display name is shown in-game
                </Text>
              )
            }
            rules={[
              {},
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || value === "") {
                    return Promise.reject(new Error("Please enter a display name."));
                  }
                  if (value.trim() !== value) {
                    return Promise.reject(new Error("The display name cannot have spaces before or after it."))
                  }
                  if (value.length > 25) {
                    return Promise.reject(new Error("The display name must be shorter than 25 characters."))
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            {user.role === "Owner" ? (
              <Tooltip placement="bottomLeft" title="Display name cannot be changed. Contact support for assistance">
                <Input placeholder={user.alias} readOnly />
              </Tooltip>
            ) : (
              <Input placeholder={user.alias} />
            )}
          </Form.Item>

          { user.role === "Owner" ? <>
            <Form.Item label="Email">
              <Tooltip placement="bottomLeft" title="Email cannot be changed. Contact support for assistance">
                <Input placeholder={maskEmail(user.username)} readOnly />
              </Tooltip>
            </Form.Item>
          </> : <></> }

          {/* {!(user.role === "User" || user.role === "GameMaster") && (
            <Form.Item
              label="Favourite Organisation"
              name="alias2"
              extra="Set a main organisation to this account"
            >
              <Select>
                {data.organizations?.map((item) => (
                  <Select.Option value={item.id}>{item.name}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          )} */}
          <div style={{ textAlign: "right" }}>
            <Button
              type="primary"
              loading={loadingState}
              htmlType="submit"
              disabled={user.role === "Owner"}
            >
              Save
            </Button>
          </div>
        </Form>
      </div>
      <div
        style={{
          background: "white",
          borderRadius: 4,
          boxShadow: "0 0 8px 0 #cbcbcb",
          padding: 20,
          marginTop: 20,
        }}
      >
        <Title level={5}>Password</Title>
        <Button type="primary" ghost onClick={() => setShowResetPWModal(true)}>
          Change Password
        </Button>
      </div>
    </>
  );
};

export default SettingsPage;
